import {CommonModule} from '@angular/common';
import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';

import {BasicPlanLimit} from '../models/basic-plan-limit.model';
import {basicTermLastDay, basicTermResetDate} from './basic-plan-term';

export interface BasicPlanConfirmationDialogData {
  entitlement: BasicPlanLimit;
}

@Component({
  selector: 'app-basic-plan-confirmation-dialog',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatDialogModule],
  templateUrl: './basic-plan-confirmation-dialog.component.html',
  styleUrl: './basic-plan-confirmation-dialog.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class BasicPlanConfirmationDialogComponent {
  constructor(
    public readonly dialogRef: MatDialogRef<BasicPlanConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data: BasicPlanConfirmationDialogData
  ) {
    dialogRef.disableClose = true;
  }

  get isOverLimit(): boolean {
    return this.data.entitlement.used > this.data.entitlement.limit;
  }

  get termLastDay(): string | undefined {
    return basicTermLastDay(this.data.entitlement);
  }

  get termResetDate(): string | undefined {
    return basicTermResetDate(this.data.entitlement);
  }
}
